import ContactForm from '../component/ContactForm';
import { Mail, Phone } from 'lucide-react';
import '../styles/Contact.css';
import { Helmet } from "react-helmet-async";
export const metadata = {
  title: 'Contact Us | Planbanalo',
  description: 'Reach out to Planbanalo for yoga retreats, camping inquiries and custom experiences.',
};

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us | PlanBanaLo</title>
        <meta
          name="description"
          content="Contact PlanBanaLo to book camping trips, yoga retreats, and adventure experiences."
        />
      </Helmet>
      <main className="contact-main">

        {/* HERO SECTION */}
        <section className="contact-header">
          <div className="header-overlay"></div>

          <div className="header-content">
            <h1 className="header-title">
              Let’s Create Something <span className="highlight">Beautiful</span>
            </h1>

            <p className="header-subtitle">
              Whether you're planning a retreat, camping adventure,
              or have a custom inquiry — we're here to help.
            </p>

            <div className="header-divider"></div>
          </div>
        </section>


        {/* MAIN SECTION */}
        <section className="contact-content">
          <div className="content-container">

            <div className="content-grid">

              {/* FORM SIDE */}
              <div className="form-wrapper">
                <div className="form-card">
                  <div className="form-header">
                    <h2>Send Us a Message</h2>
                    <p>Fill the details and our team will reach out shortly.</p>
                  </div>
                  <ContactForm />
                </div>
              </div>


              {/* INFO SIDE */}
              <div className="info-wrapper">
                <div className="info-card">
                  <div className="info-header">
                    <Mail size={22} />
                    <h3>Email</h3>
                  </div>
                  <p>planbanalo@gmail.com</p>
                </div>

                <div className="info-card">
                  <div className="info-header">
                    <Phone size={22} />
                    <h3>Phone</h3>
                  </div>
                  <p>+91  88005 77221</p>
                </div>



                <div className="hours-card">
                  <h3>Business Hours</h3>

                  <div className="hours-row">
                    <span>Mon – Fri</span>
                    <span>9:00 AM – 6:00 PM</span>
                  </div>

                  <div className="hours-row">
                    <span>Saturday</span>
                    <span>10:00 AM – 4:00 PM</span>
                  </div>

                  <div className="hours-row closed">
                    <span>Sunday</span>
                    <span>Closed</span>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </section>


        {/* FOOTER BADGE */}
        <section className="contact-footer">
          <div className="footer-badge">
            ⏱️ We usually respond within <span>24 Hours</span>
          </div>
        </section>

      </main>
    </>
  );

}